import { render, staticRenderFns } from "./LKPublicationsFormdataStatsList.vue?vue&type=template&id=dc76d9a6&scoped=true&"
import script from "./LKPublicationsFormdataStatsList.vue?vue&type=script&lang=js&"
export * from "./LKPublicationsFormdataStatsList.vue?vue&type=script&lang=js&"
import style0 from "./LKPublicationsFormdataStatsList.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./LKPublicationsFormdataStatsList.vue?vue&type=style&index=1&id=dc76d9a6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc76d9a6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VChip,VDataTable})
